export default {
    getTaskFlowList: '/tasks/flows/list',
    addTaskFlow: '/tasks/flows',
    getTaskFlowDetail: '/tasks/flows/',
    changeTaskFlowStatus: '/tasks/flows/',
    editTaskFlow: '/tasks/flows/',
    getTaskRuleList: '/tasks/rules/list',
    addTaskRule: '/tasks/rules',
    editTaskRule: '/tasks/rules/',
    deleteTaskRule: '/tasks/rules/',
    getTaskRuleDetail: '/tasks/rules/',
    getTaskGroup: '/tasks/groups/list',
    addTaskGroup: '/tasks/groups',
    deleteTaskGroup: '/tasks/groups/',
    editTaskGroup: '/tasks/groups/',
    changeTaskRuleOrder: '/tasks/rules/move/',
    newAutoTrigger: '/tasks/rules/trigger', 
    autoTriggerDetail:'/tasks/rules/trigger/', // 自动触发详情
    updateAutoTrigger: '/tasks/rules/trigger/', // 自动触发详情
    deleteAutoTrigger: '/tasks/rules/trigger/', // 自动触发详情
}